module.exports = __webpack_public_path__ + "img/kangaroo pocket width.e4166aca.png";